import * as React from 'react';
import { SVGProps } from 'react';

function SvgErrorFilled(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      data-name="error (filled)"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        data-name="\u21B3Color"
        d="M12 22a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10Zm-1-7v2h2v-2Zm0-8v6h2V7Z"
      />
    </svg>
  );
}

export default SvgErrorFilled;
